export default __webpack_public_path__ + "static/media/caveat-v9-latin_cyrillic-regular.233a5082.woff";